import { CommandHandlerResolver } from '../../../core/service/command/command-handler-resolver.service';
import { Injectable } from '@angular/core';
import { ControlDataExportCommand } from '../../../rent/command/control-data-export.command';
import { PrintControlDataCommandHandler } from './print-control-data-command-handler.service';
import { RegenerateControlDataCommandHandler } from './regenerate-control-data-command-handler.service';

@Injectable()
export class ControlDataFormCommandHandlerResolver extends CommandHandlerResolver {
  constructor(print: PrintControlDataCommandHandler, regenerateControlData: RegenerateControlDataCommandHandler) {
    super();
    this.addHandler(ControlDataExportCommand.printToPdf, print);
    this.addHandler(ControlDataExportCommand.regenerateControlData, regenerateControlData);
  }
}
